<template>
    <router-view/>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
/* Import Font Awesome Icons Set */
$fa-font-path: '~font-awesome/fonts/';
@import '~font-awesome/scss/font-awesome.scss';
/* Import Bootstrap Vue Styles */
//@import '~bootstrap-vue/dist/bootstrap-vue.css';
</style>



// WEBPACK FOOTER //
// src/App.vue